const entryFleetTutorial = {
  module: 'entry_fleet',
  moduleName: 'Entry Fleet',
  steps: [
    { target: '.entry-header', position: 'bottom', title: 'Entry Fleet', description: 'Manage your facial recognition tablet kiosks.' },
    { target: '.entry-header-actions .btn-primary', position: 'bottom', title: 'Enroll Device', description: 'Add a new Entry tablet to your fleet.' },
    { target: '.entry-license-banner', position: 'bottom', title: 'License', description: 'Your Entry license limits and usage at a glance.' },
  ],
};
export default entryFleetTutorial;
